enum IntegrationProviderId {
  PLUTIO = "plutio",
  GITHUB = "github",
  AIRTABLE = "airtable",
  DROPBOX = "dropbox",
  GOOGLE = "google",
  NOTION = "notion",
}

export { IntegrationProviderId };
